// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/" + {"353":"reactPlayerPreview","363":"ja-json","800":"ko-json","864":"zh-json"}[chunkId] + ".js";
};